import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { ConfirmationService } from 'primeng/api';
import { selectPersonasList } from '../../store/selectors/personas.selectors';
import { IAppState } from '../../store/app.state';
import { ICreatePersona, IPersona, IUpdatePersona } from '../../interfaces/personas.interface';
import { map, tap } from 'rxjs/operators';
import { DownloadService } from 'src/app/services/download.service';
import { Table } from 'primeng/table';
import {
  CreatePersona, CreatePersonaSuccess, DeletePersona, DeletePersonaSuccess,
  GetPersonas, UpdatePersona, UpdatePersonaSuccess
} from '../../store/actions/personas.actions';
import { selectProgramasList } from 'src/app/store/selectors/programas.selectors';
import { selectCentrosList } from 'src/app/store/selectors/centros.selectors';
import { GetProgramas } from 'src/app/store/actions/programas.actions';
import { GetCentros } from 'src/app/store/actions/centros.actions';
import { ExportExcelService } from 'src/app/services/export-excel.service';

@Component({
  selector: 'app-personas',
  templateUrl: './personas.component.html',
  styleUrls: ['./personas.component.scss']
})
export class PersonasComponent implements OnInit, OnDestroy {
  @ViewChild('dt', { static: false }) table: Table;

  personas = this.store$.pipe(
    select(selectPersonasList),
    map(personas => personas.map(persona => {
      this.colaboradoresExcel.push(persona);
      return {
        ...persona,
        tipo: persona.tipo === '' ? 'N/A' : persona.tipo,
        programa: persona.programa === '' ? 'N/A' : persona.programa,
        centro: persona.centro === '' ? 'N/A' : persona.centro,
        mes_inicio: persona.mes_inicio === '' ? 'N/A' : persona.mes_inicio,
        especialidad: persona.especialidad === '' ? 'N/A' : persona.especialidad
      }
    }))
  );

  programas = this.store$.pipe(
    select(selectProgramasList),
    map(programas => programas.map(programa => {
      return { label: programa.programa_social, value: programa.programa_social }
    }))
  );

  centros = this.store$.pipe(
    select(selectCentrosList),
    map(centros => centros.map(centro => {
      return { label: centro.nombre, value: centro.nombre }
    }))
  );

  cols: any[];
  mode = '';
  header = '';
  displayForm = false;
  colaboradoresExcel = [];
  dataForExcel = [];

  tipos = [
    { label: 'Facilitador/Facilitadora', value: 'Facilitador/Facilitadora' },
    { label: 'Mentor/Mentora', value: 'Mentor/Mentora' },
    { label: 'Coordinador/Coordinadora', value: 'Coordinador/Coordinadora' }
  ];

  especialidad = [
    { label: 'Emprendimiento', value: 'Emprendimeinto' },
    { label: 'Finanzas', value: 'Finanzas' },
    { label: 'Desarrollo Humano', value: 'Desarrollo Humano' },
    { label: 'Proyecto de Vida', value: 'Proyecto de Vida' },
    { label: 'Oficios', value: 'Oficios' },
    { label: 'Computación', value: 'Computacion' },
    { label: 'Marketing', value: 'Marketing' },
    { label: 'Mentoria', value: 'Mentoria' },
    { label: 'Otra', value: 'Otra' }
  ];

  meses = [
    { label: 'Enero', value: 'Enero' },
    { label: 'Febrero', value: 'Febrero' },
    { label: 'Marzo', value: 'Marzo' },
    { label: 'Abril', value: 'Abril' },
    { label: 'Mayo', value: 'Mayo' },
    { label: 'Junio', value: 'Junio' },
    { label: 'Julio', value: 'Julio' },
    { label: 'Agosto', value: 'Agosto' },
    { label: 'Septiembre', value: 'Septiembre' },
    { label: 'Octubre', value: 'Octubre' },
    { label: 'Noviembre', value: 'Noviembre' },
    { label: 'Diciembre', value: 'Diciembre' }
  ];

  downloadItems = [
    { label: 'CSV', command: () => { this.downloadService.exportCSV('personas', this.table) } },
    { label: 'PDF', command: () => { this.downloadService.exportPdf('personas', this.table) } },
  ];

  formPersona: FormGroup;

  formSubmitSubscription = this.actions$.pipe(
    ofType(UpdatePersonaSuccess, DeletePersonaSuccess, CreatePersonaSuccess),
    tap(_ => {
      this.store$.dispatch(GetPersonas());
      this.displayForm = false;
    })
  ).subscribe();

  constructor(
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private store$: Store<IAppState>,
    private actions$: Actions,
    public downloadService: DownloadService,
    private ete: ExportExcelService
  ) {
    this.formPersona = this.formBuilder.group({
      _id: new FormControl(''),
      tipo: new FormControl(''),
      nombre: new FormControl(''),
      apellido_paterno: new FormControl(''),
      apellido_materno: new FormControl(''),
      programa: new FormControl(''),
      celular: new FormControl(''),
      email: new FormControl(''),
      profesion: new FormControl(''),
      especialidad: new FormControl(''),
      cursos: new FormControl(''),
      empleos: new FormControl(''),
      centro: new FormControl(''),
      year_inicio: new FormControl(''),
      mes_inicio: new FormControl(''),
      year_nacimiento: new FormControl(''),
      municipio: new FormControl(''),
      colonia: new FormControl(''),
      curp: new FormControl(''),
      responsabilidades: new FormControl(''),
    });
  }

  async ngOnInit() {
    this.cols = [
      { field: 'tipo', header: 'Tipo de colaborador', exportable: true },
      { field: 'nombre', header: 'Nombre', exportable: true },
      { field: 'apellido_paterno', header: 'Apellido Paterno', exportable: true },
      { field: 'apellido_materno', header: 'Apellido Materno', exportable: true },
      { field: 'celular', header: 'Celular', exportable: true },
      { field: 'acciones', header: 'Acciones', exportable: false }
    ];

    this.store$.dispatch(GetPersonas())
    this.store$.dispatch(GetProgramas());
    this.store$.dispatch(GetCentros());
  }

  async ngOnDestroy() {
    this.formSubmitSubscription.unsubscribe();
  }

  editarPersona(Persona): void {
    this.mode = 'EDITAR'
    this.header = 'Editar Colaborador';
    this.formPersona.patchValue({
      ...Persona
    });
    this.formPersona.enable();

    this.displayForm = true;
  }

  verPersona(Persona): void {
    this.mode = 'DETALLE'
    this.header = 'Detalle Colaborador'
    this.formPersona.patchValue({
      ...Persona
    });
    this.formPersona.disable();

    this.displayForm = true;
  }

  agregarPersona() {
    this.mode = 'AGREGAR'
    this.header = 'Agregar Colaborador'
    this.formPersona.patchValue({
      _id: '',
      tipo: '',
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      programa: '',
      celular: '',
      email: '',
      profesion: '',
      especialidad: '',
      cursos: '',
      empleos: '',
      centro: '',
      year_inicio: '',
      mes_inicio: '',
      year_nacimiento: '',
      municipio: '',
      colonia: '',
      curp: '',
      responsabilidades: '',
    })
    this.formPersona.enable();

    this.displayForm = true;
  }

  borrarPersona(persona: IPersona) {
    this.confirmationService.confirm({
      header: 'Borrar Persona',
      message: `¿Seguro que quiere borrar al colaborador '${persona.nombre}'?`,
      acceptLabel: 'Aceptar',
      rejectVisible: false,
      accept: async () => {
        this.store$.dispatch(DeletePersona({ id: persona._id }))
      }
    });
  }

  submitForm() {
    const form: IPersona = this.formPersona.getRawValue();

    if (this.mode === 'AGREGAR') {
      const payload: ICreatePersona = {
        ...form,
      }

      this.store$.dispatch(CreatePersona({ persona: payload }));
    } else if (this.mode === 'EDITAR') {
      const payload: IUpdatePersona = {
        ...form,
      }

      this.store$.dispatch(UpdatePersona({ id: form._id, persona: payload }));
    }

    return;
  }

  exportToExcel() {
    this. dataForExcel = [];

    const uniqueArray = this.colaboradoresExcel.filter((value, index) => {
      const _value = JSON.stringify(value);
      return index === this.colaboradoresExcel.findIndex(obj => {
        return JSON.stringify(obj) === _value;
      });
    });

    uniqueArray.forEach((row: any) => {
      const insert = { ...row }
      this.dataForExcel.push(Object.values(insert))
    })

    const headers = {
      id: '',
      tipo: '',
      nombre: '',
      'apellido paterno': '',
      'apellido materno': '',
      programa: '',
      celular: '',
      email: '',
      profesion: '',
      especialidad: '',
      cursos: '',
      empleos: '',
      centro: '',
      'año de inicio': '',
      'mes de inicio': '',
      'año de nacimiento': '',
      municipio: '',
      colonia: '',
      curp: '',
      responsabilidades: '',
    }

    const reportData = {
      title: 'Colaboradores',
      data: this.dataForExcel,
      headers: Object.keys(headers)
    }

    this.ete.exportExcel(reportData, false);
  }
}
